import {
  Injectable
} from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import {
  Observable,
  map,
  of
} from 'rxjs';
import {
  Data2Service
} from '../services/data2/data2.service';
import { Globals } from '../globals';
import { ConsentService } from '../services/consent.service';
import { HeadService } from '../services/head.service';
import { JsonldserviceService } from '../services/jsonldservice.service';

@Injectable({
  providedIn: 'root'
})

export class MasterGuard {


  constructor(
    private router: Router,
    private data2Service: Data2Service,
    private head: HeadService,
    private jsonLDService: JsonldserviceService) {}


  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable < boolean | UrlTree > | Promise < boolean | UrlTree > | boolean | UrlTree {

    var h = new Headers();
    //     console.log("Headers:",h)
    var s = seo.find(x => state.url == x.route);


    if (s != null) {
        //console.log("Found matching SEO data:",state.url,s)
        this.head.setTitle(s.title);
        this.head.setDescription(s.description);
        this.head.setKeywords(s.keywords);
    } else {
        //console.warn("Missing matching SEO data for route:",state.url)
    }

    //console.log("MASTER GUARD > State.url > ",state.url)

    if (this.isWhitelisted(state.url)) {
        if (s != null) {
            this.jsonLDService.removeStructuredData();
            this.jsonLDService.insertSchema(this.jsonLDService.getPageSchema(s.title, "https://www.ifainstitutional.com" + s.route, s.description))
        }
        //        console.log(`Route '${state.url}' is whitelisted to be seen without consent.`);        
        //console.log("pagesThatDoNotContainHypotheticalBacktestedData.indexOf(state.url)>-1",pagesThatDoNotContainHypotheticalBacktestedData.indexOf(state.url)>-1, state.url)
        return true;
    } else {
        //console.log("MASTER AUTH GUARD > canActivateChild",state.url);
        return this.canActivate(childRoute, state);
    }
}

canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable < boolean | UrlTree > | Promise < boolean | UrlTree > {

  //STATIC LIST OF WHITELISTED CONTENT
  if (this.isWhitelisted(state.url)) {
      return of(true);
  }  

  //RECORD OF CONSENTING ALREADY EXISTS
  var ls = localStorage.getItem("consents");
  if (ls != null) {
      var lsp = JSON.parse(ls)
      //      console.log("lsp",lsp)
      if (lsp[0].answer == "true") {
          return of(true);
      }
  }

  //CHECK THE DATA2 API FOR WHITELISTED ARTICLE OR VIDEO
  var regexAV = "/(articles|videos)/([a-z0-9A-Z_-]+)/?"
  var matchesAV = state.url.match(regexAV);
  if (matchesAV != null) {
      return this.data2Service.articleVideoWhitelistCheck$(matchesAV[2]).pipe(map((wl: boolean) => {
          if (wl) {
              return true;
          } else {
              this.routeElsewhere2(state);
              return false;
          }
      }));
  } else {
      this.routeElsewhere2(state);
      return of(false);
  }
}
routeElsewhere2(state: RouterStateSnapshot) {
  localStorage.setItem("intercepted-route", JSON.stringify({
      url: state.url,
      date: new Date()
  }));
  var hasPreviousNavigation = Boolean(this.router.getCurrentNavigation()?.previousNavigation)
  //console.log("hasPreviousNavigation",hasPreviousNavigation)
  if (!hasPreviousNavigation) {
      var matches = pagesThatDoNotContainHypotheticalBacktestedData.filter(x => state.url.startsWith(x));
      //console.log("matches",matches)
      if (matches != null) {
          var longest = matches.reduce(
              function(a, b) {
                  return a.length > b.length ? a : b;
              }
          );
          //console.log("longest",longest);
          setTimeout(() => {
              this.router.navigate([longest]);
          }, 1500)
      } else {
          this.router.navigate(['/']);
      }
      setTimeout(() => {
          //this.globals.signInModalEvents.emit(true); //MIKE A: 2023-02-10 As per Mark H we now just redirect to the consent page
          this.router.navigate(['/required-consent']);
      }, 2000)
      //console.log("in 2 seconds the globals.signInModalEvents will emit")
      //return false;
  } else {
      //this.globals.signInModalEvents.emit(true); //MIKE A: 2023-02-10 As per Mark H we now just redirect to the consent page
      this.router.navigate(['/required-consent']);
      //console.log("the globals.signInModalEvents will emit")
      //return false;
  }
}

  isWhitelisted(r: string) {
    return (pagesThatDoNotContainHypotheticalBacktestedData.indexOf(r) > -1 ||
      r.indexOf("/quotes/") == 0);
  }
}

//WHITELIST - ALL PAGES REQUIRE CONSENT EXCEPT THESE:
//ALPHABETICALLY LISTED
//NO PAGES BELOW SHOULD HAVE ANY HYPOTHETICAL BACKTESTED DATA / CHARTS / VIDEOS etc.
var pagesThatDoNotContainHypotheticalBacktestedData = [
  "/",
  "/404",
  "/about",
  "/about/advisors",
  "/articles",
  "/books",
  "/client-experience",
  "/contact",
  "/disclosures",
  "/disclosures/index-data",
  "/disclosures/terms",
  "/essential-reading",
  "/evidence",
  "/investment-philosophy",
  "/who-we-serve",
  "/research",
  "/approach",
  "/kerrie-lloyd",
  "/mark-higgins",
  "/mary-brunson",
  "/nick-piccarreta",
  "/adriana-ise",
  "/david-york",
  "/high-net-worth",
  "/high-net-worth/advisory-team",
  "/high-net-worth/investment-philosophy",
  "/high-net-worth/research",
  "/high-net-worth/services",
  "/high-net-worth/who-we-serve",

  "/our-approach",
  "/required-consent",
  "/videos",
  
]

export class IFAMeta {
  route = "";
  title = "";
  description = "";
  keywords = "";
  constructor(_route: string, _title: string, _keywords: string, _description: string) {
      this.route = _route;
      this.title = _title;
      this.keywords = _keywords;
      this.description = _description;
  }
}

var seo = [
  new IFAMeta('/', 'IFA Institutional & High Net Worth', 'Index Funds, Financial Advisor', 'Index Fund Advisors is a fee-only independent fiduciary financial advisor that specializes in risk-appropriate portfolios of index funds.'),
  new IFAMeta('/about', 'About IFA Institutional & High Net Worth', 'Index Funds, Financial Advisor', 'IFA Institutional & High Net Worth is a division of Index Fund Advisors., a fee-only independent fiduciary financial advisor that specializes in risk-appropriate portfolios of index funds.'),
  new IFAMeta('/articles', 'Articles - IFA Institutional & High Net Worth', 'Index Funds, Financial Advisor', 'IFA Institutional & High Net Worth is a division of Index Fund Advisors., a fee-only independent fiduciary financial advisor that specializes in risk-appropriate portfolios of index funds.'),
  new IFAMeta('/books', 'Books - IFA Institutional & High Net Worth', 'Index Funds, Financial Advisor', 'IFA Institutional & High Net Worth is a division of Index Fund Advisors., a fee-only independent fiduciary financial advisor that specializes in risk-appropriate portfolios of index funds.'),
  new IFAMeta('/contact', 'Contact IFA Institutional & High Net Worth', 'Index Funds, Financial Advisor', 'IFA Institutional & High Net Worth is a division of Index Fund Advisors., a fee-only independent fiduciary financial advisor that specializes in risk-appropriate portfolios of index funds.'),
  new IFAMeta('/disclosures', 'Disclosures - IFA Institutional & High Net Worth', 'Index Funds, Financial Advisor', 'IFA Institutional & High Net Worth is a division of Index Fund Advisors., a fee-only independent fiduciary financial advisor that specializes in risk-appropriate portfolios of index funds.'),
  new IFAMeta('/investment-philosophy', 'Investment Philosophy - IFA Institutional & High Net Worth', 'Index Funds, Financial Advisor', 'IFA Institutional & High Net Worth is a division of Index Fund Advisors., a fee-only independent fiduciary financial advisor that specializes in risk-appropriate portfolios of index funds.'),
  new IFAMeta('/approach', 'Approach - IFA Institutional & High Net Worth', 'academic evidence, financial history, practical investment experience', 'Informed investors make better long-term decisions, research combines academic evidence, financial history, and practical investment experience to help clients understand today\'s markets through a long-term lens.'),
  new IFAMeta('/who-we-serve', 'Who We Serve - IFA Institutional & High Net Worth', 'academic evidence, financial history, practical investment experience', 'Informed investors make better long-term decisions, research combines academic evidence, financial history, and practical investment experience to help clients understand today\'s markets through a long-term lens.'),
  new IFAMeta('/research', 'Research - IFA Institutional & High Net Worth', 'academic evidence, financial history, practical investment experience', 'Informed investors make better long-term decisions, research combines academic evidence, financial history, and practical investment experience to help clients understand today\'s markets through a long-term lens.'),
  new IFAMeta('/high-net-worth', 'High Net Worth - IFA Institutional & High Net Worth', 'Index Funds, Financial Advisor', 'IFA Institutional & High Net Worth is a division of Index Fund Advisors., a fee-only independent fiduciary financial advisor that specializes in risk-appropriate portfolios of index funds.'),
  new IFAMeta('/high-net-worth/advisory-team', 'Advisory Team - IFA Institutional & High Net Worth', 'Index Funds, Financial Advisor', 'IFA Institutional & High Net Worth is a division of Index Fund Advisors., a fee-only independent fiduciary financial advisor that specializes in risk-appropriate portfolios of index funds.'),
  new IFAMeta('/high-net-worth/investment-philosophy', 'Investment Philosophy - IFA Institutional & High Net Worth', 'Index Funds, long-term, fee minimalization, low-cost passive, portfolio rebalancing', 'Enduring principles that have withstood decades of academic scrutiny and nearly 250 years of financial history'),
  new IFAMeta('/high-net-worth/research', 'Research - IFA Institutional & High Net Worth', 'academic evidence, financial history, practical investment experience', 'Informed investors make better long-term decisions, research combines academic evidence, financial history, and practical investment experience to help clients understand today\'s markets through a long-term lens.'),
  new IFAMeta('/high-net-worth/services', 'Services - IFA Institutional & High Net Worth', 'Index Funds, Financial Advisor', 'IFA Institutional & High Net Worth is a division of Index Fund Advisors., a fee-only independent fiduciary financial advisor that specializes in risk-appropriate portfolios of index funds.'),
  new IFAMeta('/high-net-worth/who-we-serve', 'Who We Serve - IFA Institutional & High Net Worth', 'Index Funds, Financial Advisor', 'IFA Institutional & High Net Worth is a division of Index Fund Advisors., a fee-only independent fiduciary financial advisor that specializes in risk-appropriate portfolios of index funds.'),
  new IFAMeta('/mark-higgins', 'Mark Higgins - IFA Institutional Vice President', 'Index Funds, Financial Advisor', 'IFA Institutional & High Net Worth is a division of Index Fund Advisors., a fee-only independent fiduciary financial advisor that specializes in risk-appropriate portfolios of index funds.'),
  new IFAMeta('/kerrie-lloyd', 'Kerrie Lloyd - IFA Institutional Consultant', 'Index Funds, Financial Advisor', 'IFA Institutional & High Net Worth is a division of Index Fund Advisors., a fee-only independent fiduciary financial advisor that specializes in risk-appropriate portfolios of index funds.'),
  new IFAMeta('/mary-brunson', 'Mary Brunson - Investing for Catholics Vice President', 'Index Funds, Financial Advisor', 'IFA Institutional & High Net Worth is a division of Index Fund Advisors., a fee-only independent fiduciary financial advisor that specializes in risk-appropriate portfolios of index funds.'),

  new IFAMeta('/david-york', 'David York - IFA Institutional', 'Index Funds, Financial Advisor, Director of Financial & Tax Planning', 'David York is a member of the IFA Institutional & High Net Worth advisory team at Index Fund Advisors, a fee-only independent fiduciary financial advisor.'),
  new IFAMeta('/adriana-ise', 'Adriana Ise - IFA Institutional', 'Index Funds, Financial Advisor, Senior Client Service Specialist', 'Adriana Ise is a member of the IFA Institutional & High Net Worth advisory team at Index Fund Advisors, a fee-only independent fiduciary financial advisor.'),
  new IFAMeta('/about/advisors', 'Advisory Team - IFA Institutional & High Net Worth', 'Institutional Consultants, Fiduciary Advisors', 'Meet the IFA Institutional & High Net Worth advisory team, a division of Index Fund Advisors.'),
  //new IFAMeta('/charts', 'Charts - IFA Institutional & High Net Worth', 'Index Fund Charts, Market Data, Risk and Return', 'Interactive charts illustrating long-term index fund risk and return data from IFA Institutional.'),
  //new IFAMeta('/events', 'Events - IFA Institutional & High Net Worth', 'Institutional Investing Events, Webinars', 'Upcoming events and webinars from IFA Institutional & High Net Worth, a division of Index Fund Advisors.'),
  //new IFAMeta('/fiduciary', 'Fiduciary Services - IFA Institutional & High Net Worth', '3(21) Fiduciary, 3(38) Fiduciary, Plan Sponsor', 'Fiduciary investment advisory services for plan sponsors, endowments, and foundations from IFA Institutional.'),
  new IFAMeta('/fees', 'Fees - IFA Institutional & High Net Worth', 'Fee-Only Advisor, Advisory Fees, Transparent Pricing', 'Transparent, fee-only advisory pricing from IFA Institutional & High Net Worth, a division of Index Fund Advisors.'),
  //new IFAMeta('/index-portfolios', 'Index Portfolios - IFA Institutional & High Net Worth', 'Index Portfolios, Risk-Appropriate Portfolios, Asset Allocation', 'Risk-appropriate globally diversified index portfolios for institutional and high net worth investors.'),
  //new IFAMeta('/videos', 'Videos - IFA Institutional & High Net Worth', 'Investing Videos, Index Funds, Evidence-Based Investing', 'Educational videos on evidence-based investing from IFA Institutional & High Net Worth.'),
  new IFAMeta('/research-library', 'Research Library - IFA Institutional & High Net Worth', 'academic evidence, financial history, practical investment experience', 'Research combining academic evidence, financial history, and practical investment experience to help clients understand markets through a long-term lens.'),
  new IFAMeta('/disclosures/index-data', 'Index Data Disclosures - IFA Institutional & High Net Worth', 'Index Data, Disclosures, Backtested Performance', 'Disclosures regarding index data and hypothetical backtested performance used by IFA Institutional.'),
  new IFAMeta('/disclosures/terms', 'Terms of Use - IFA Institutional & High Net Worth', 'Terms of Use, Disclosures', 'Terms of use for the IFA Institutional & High Net Worth website.'),
  new IFAMeta('/required-consent', 'Consent Required - IFA Institutional & High Net Worth', 'Disclosures, Consent', 'Please review and accept the disclosures to continue.'),
  new IFAMeta('/contact/success', 'Thank You - IFA Institutional & High Net Worth', 'Contact', 'Your message has been received by IFA Institutional & High Net Worth.'),
  ]